import React from 'react';
import { connect } from 'react-redux';

import Config from 'Config'
import Navigation from 'utils/navigation'
import { Paths } from 'utils/paths'
import FeedbackActions from 'actions/feedback'
import GuideActions from 'actions/guides'

import ioLogo from 'images/logos/io-logo-48-white.png'
import facebookLogo from 'images/logos/facebook-f-logo.png'
import githubLogo from 'images/logos/github-logo.png'
import tiktokLogo from 'images/logos/tiktok-logo.png'
import instagramLogo from 'images/logos/instagram-logo-outline.png'
import twitterLogo from 'images/logos/twitter-logo.png'
import youtubeLogo from 'images/logos/youtube-logo.png'
import 'stylesheets/footer.scss'

const NavLink = ({ to, children }) => {
  return (
    <a href={to} onClick={evt => {
      evt.preventDefault()
      Navigation.go(to)
    }}>{ children }</a>
  )
}

class FooterContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isReady: false,
      quote: null
    }
  }

  componentDidMount() {
    if (window.FOOTER_QUOTE && window.FOOTER_QUOTE.quote) {
      this.setState({ quote: window.FOOTER_QUOTE.quote })
    }

    // tiny delay to prevent flash of unstyled content
    this._readySetter = setTimeout(() => {
      this.setState({ isReady: true})
    }, 200)
  }

  componentWillUnmount() {
    if (this._readySetter) {
      clearTimeout(this._readySetter)
    }
  }

  navigateTo(path) {
    return Navigation.go(path)
  }

  renderQuote() {
    if (this.state.quote) {
      try {
        const quoteObject = this.state.quote

        const words = quoteObject.quote.split(" - ", 1)[0]
        const quoteClass = words > 125 ? 'quote long-quote' : 'quote normal'

        // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
        // appease React, gotta be real intentional about it if you're going to XSS yourself
        const quote = { __html: quoteObject.quote }
        const author = { __html: quoteObject.author }
        return (
          <aside>
            <div className={quoteClass} dangerouslySetInnerHTML={quote} />
            <div className="quote-attribution" dangerouslySetInnerHTML={author} />
          </aside>
        )
      } catch (ex) {
        return null
      }
    } else {
      return null
    }
  }

  render() {
    if (!this.state.isReady) return null

    return (
      <footer className="adafruit-footer">
        <div className="container footer-content">
          <div className="row row-eq-height">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
              <nav>
                <ul>
                  <li><NavLink to={Paths.support()}>Get Help</NavLink></li>
                  <li>
                    <a onClick={() => this.props.dispatch(GuideActions.showGuide('meta'))}>Quick Guides</a>
                  </li>
                  <li><a target="_blank" rel="noopener" href={Config.documentationUrl}>API Documentation</a></li>
                  <li><NavLink to={Paths.faq()}>FAQ</NavLink></li>
                  <li><NavLink to={Paths.terms()}>Terms of Service</NavLink></li>
                  <li><a target="_blank" rel="noopener" href="https://www.adafruit.com/privacy">Privacy Policy</a></li>
                  <li><a target="_blank" rel="noopener" href="https://www.adafruit.com/accessibility">Website Accessibility</a></li>
                  <li className="separator"></li>
                  <li>
                    <a onClick={() => this.props.dispatch(FeedbackActions.toggleModal(true, 'root'))}>Send Feedback</a>
                  </li>
                </ul>
              </nav>

              <img src={ioLogo} className="adafruit-logo img-responsive" alt="Adafruit IO Logo" />
            </div>

            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
              <nav>
                <ul>
                  <li><a href={Config.learnUrl}>Learn</a></li>
                  <li><NavLink to={Paths.plus()}>IO Plus</NavLink></li>
                  <li><a href="https://io.adafruit.com/blog">News</a></li>
                </ul>
              </nav>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-4 col-xs-12">
              <div className="right-content">
                { this.renderQuote() }
                <div className="social-links">
                  <ul>
                    <li><a target="_blank" rel="noopener" href="https://instagram.com/adafruit"><img src={instagramLogo} alt="Adafruit on Instagram" /></a></li>
                    <li><a target="_blank" rel="noopener" href="https://twitter.com/adafruit"><img src={twitterLogo} alt="Adafruit on Twitter" /></a></li>
                    <li><a target="_blank" rel="noopener" href="https://www.facebook.com/adafruitindustries/"><img src={facebookLogo} alt="Adafruit on Facebook" /></a></li>
                    <li><a target="_blank" rel="noopener" href="https://youtube.com/adafruit"><img src={youtubeLogo} alt="Adafruit on Youtube" /></a></li>
                    <li><a target="_blank" rel="noopener" href="https://github.com/adafruit"><img src={githubLogo} alt="Adafruit on GitHub" /></a></li>
                    <li><a target="_blank" rel="noopener" href="https://tiktok.com/@adafruit"><img src={tiktokLogo} alt="Adafruit on tiktok" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div id="footer-messaging" className="col-xs-12">
              <a href="https://www.adafruit.com/about">A Minority and Woman-owned Business Enterprise (M/WBE)</a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default connect()(FooterContainer);
